import React from 'react';
import './Footer.css'

const Footer = () => {
  return <div className='footer'>
    Made by Oleg Kupriianov
  </div>
};


export default Footer


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js